

































































































import { Component } from "vue-property-decorator";
import {
  Evento,
  EventosService,
  FiltrosEvento,
} from "@/services/eventos.service";
import DataTable, { TableHeader } from "@/shared/components/data-table.vue";
import Tooltip from "@/shared/components/tooltip.vue";
import Confirm from "@/shared/components/confirm.vue";
import DatePicker from "@/shared/components/date-picker.vue";
import { dateTime } from "@/shared/filters";
import dayjs from "dayjs";
import GlobalMixin from "@/shared/mixins/globalMixin";
import { mixins } from "vue-class-component";
import { ServerPageOptions } from "@/shared/utils/datatable";

import Detalhes from "./components/DetalhesEventoRow.vue";

@Component({
  components: { DataTable, Tooltip, DatePicker, Confirm, Detalhes },
  filters: { dateTime },
})
export default class Eventos extends mixins(GlobalMixin) {
  filtro: FiltrosEvento = {
    dataDe: "",
    dataAte: "",
    idConsultor: "",
    apenasComErro: true,
    offset: 0,
    limit: 100,
    order: "",
  };
  loading = false;
  eventos: Promise<Evento[]> | null = null;
  headers: TableHeader[] = [
    { value: "idConsultor", text: "IdConsultor" },
    { value: "acao", text: "Ação" },
    { value: "dataCriacao", text: "Data Criação" },
    { value: "dataRecebimento", text: "Data Recebimento" },
    { value: "dataProcessamento", text: "Data Processamento" },
    { value: "status", text: "Status" },
    { value: "acoes", text: "Ações", sortable: false },
  ];
  created() {
    this.filtro.dataAte = dayjs().format("YYYY-MM-DD");
    this.filtro.dataDe = dayjs().subtract(7, "day").format("YYYY-MM-DD");
  }
  async fetchEventos(options?: ServerPageOptions) {
    this.loading = true;
    if (this.filtro.dataAte.length == 10) {
      this.filtro.dataAte = this.filtro.dataAte + " 23:59:59";
    }
    if (options) {
      Object.assign(this.filtro, options);
    }
    this.eventos = EventosService.listar(this.filtro);
    this.loading = false;
  }
  submitForm() {
    const form = this.$refs.form as any;
    if (form.validate()) {
      this.fetchEventos();
    }
  }
  consultorOuErro() {
    if (this.filtro.apenasComErro || (this.filtro.idConsultor ? true : false)) {
      return true;
    }
    return "Selecione pelo menos um consultor ou apenas com erro";
  }
  async marcarPendente(item: Evento) {
    const modalConfirm = this.$refs.confirm as Confirm;
    const title = `Marcar evento como pendente`;
    const text = `Deseja realmente marcar como pendente o evento de acao ${item.acao} ?`;
    const res = await modalConfirm.open(title, text);
    if (res) {
      this.startLoader();
      await EventosService.marcarComoPendente(item.idEvento).finally(
        this.stopLoader
      );
      this.fetchEventos();
    }
  }
  async ignorarRegistro(item: Evento) {
    const modalConfirm = this.$refs.confirm as Confirm;
    const title = `Ignorar Registro`;
    const text = `Deseja realmente ignorar o evento de acao ${item.acao} ?`;
    const res = await modalConfirm.open(title, text);
    if (res) {
      this.startLoader();
      await EventosService.ignorarRegistro(item.idEvento).finally(
        this.stopLoader
      );
      this.fetchEventos();
    }
  }
}
